<canvasjs-chart [options]="canvasChart"></canvasjs-chart>